import React from 'react';
import { FadeIn } from './FadeIn';
import { Rocket } from 'lucide-react';
export function Proof() {
  return <section className="py-16 bg-cream px-4 sm:px-6 lg:px-8" data-id="element-201">
      <div className="max-w-4xl mx-auto" data-id="element-202">
        <FadeIn data-id="element-203">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-soft border border-gold/20 relative overflow-hidden" data-id="element-204">
            <div className="absolute top-0 right-0 p-8 opacity-10" data-id="element-205">
              <Rocket className="w-32 h-32 text-gold" data-id="element-206" />
            </div>

            <div className="relative z-10" data-id="element-207">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-darkText mb-6" data-id="element-208">
                Resultados en Tiempo Récord
              </h2>
              <p className="text-lg md:text-xl text-lightText leading-relaxed mb-6" data-id="element-209">
                <strong className="text-darkText font-bold" data-id="element-210">
                  En solo 7 días
                </strong>
                , podrías tener tu primera colección de 3 cuadros infantiles
                publicada.
              </p>
              <p className="text-lg text-lightText leading-relaxed" data-id="element-211">
                Mientras otros gastan semanas dibujando a mano, tú estarás
                operando con la velocidad de la IA, permitiéndote probar qué
                nichos funcionan más rápido sin arriesgar capital.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}